module.exports = __webpack_public_path__ + "img/person.9b8d046a.svg";